/**
 * Copyright 2023 Design Barn Inc.
 */

import type { AudioOptions } from '../common';
import { LottieAudioCommon } from '../common';

export class LottieAudio extends LottieAudioCommon {
  public constructor(options: AudioOptions) {
    super(options);
  }
}
